import React, { Component } from 'react'
import { withRouter } from '../../utils/with-router'
import './Contact.css'
import {Link} from "react-router-dom";
import { getQA } from '../../fetcher';
class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            firstname:'',
            lastname:'',
            title:'',
            company:'',
            subject:'',
            message: '',
            wordCount:0,
            errors: {},
            focusedInput: '', // 记录当前选中的输入框
            buttonDesign1: 'plus_button',
            buttonDesign2: 'plus_button',
            buttonDesign3: 'plus_button',
            buttonDesign4: 'plus_button',
            buttonDesign5: 'plus_button',
            buttonDesign6: 'plus_button',
            buttonDesign7: 'plus_button',
            buttonDesign8: 'plus_button',
            showContent1: false,
            showContent2: false,
            showContent3: false,
            showContent4: false,
            showContent5: false,
            showContent6: false,
            showContent7: false,
            showContent8: false,
            isMobile: window.innerWidth <= 480,
            submitted: false,
            questions:[],
            answers:[]
        };

        this.firstnameInput = React.createRef(); // 创建一个 ref
        this.lastnameInput = React.createRef(); // 创建一个 ref
        this.titleInput = React.createRef(); // 创建一个 ref
        this.companyInput = React.createRef(); // 创建一个 ref
        this.messageInput = React.createRef(); // 创建一个 ref
        this.emailInput = React.createRef(); // 创建一个 ref
    }



    componentDidMount() {
        this.fetchQAData();
      }

      fetchQAData = async () => {
        try {
          const qaData = await getQA();
          let qs=[]
          let as=[]
          qaData.records.forEach((speakerContentElement, index) => {
            const qa = qaData.records[index].fields;
            
            qs.push(qa.Question)
            as.push(qa.Answer)
          });

          this.setState({questions:qs})
          this.setState({answers:as})
          console.log(qs)
          console.log(as)

        } catch (error) {
          console.error(error);
        }
      };

    clickCancel= () => {
        this.setState(() => ({
            submitted: false,
        }));
    };

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };



    handleInputFocus = (inputName) => {
        this.setState({
            focusedInput: inputName,

        });
        if (inputName === 'firstname') {
            const inputElement = this.firstnameInput.current;
            if (inputElement) {
                inputElement.value = '  ' + inputElement.value;
                inputElement.selectionStart = 2; // 设置光标的起始位置
                inputElement.selectionEnd = 2; // 设置光标的结束位置
            }
        }
        if (inputName === 'lastname') {
            const inputElement = this.lastnameInput.current;
            if (inputElement) {
                inputElement.value = '  ' + inputElement.value;
                inputElement.selectionStart = 2; // 设置光标的起始位置
                inputElement.selectionEnd = 2; // 设置光标的结束位置
            }
        }
        if (inputName === 'title') {
            const inputElement = this.titleInput.current;
            if (inputElement) {
                inputElement.value = '  ' + inputElement.value;
                inputElement.selectionStart = 2; // 设置光标的起始位置
                inputElement.selectionEnd = 2; // 设置光标的结束位置
            }
        }
        if (inputName === 'company') {
            const inputElement = this.companyInput.current;
            if (inputElement) {
                inputElement.value = '  ' + inputElement.value;
                inputElement.selectionStart = 2; // 设置光标的起始位置
                inputElement.selectionEnd = 2; // 设置光标的结束位置
            }
        }
        if (inputName === 'message') {
            const inputElement = this.messageInput.current;
            if (inputElement) {
                inputElement.value = '  ' + inputElement.value;
                inputElement.selectionStart = 2; // 设置光标的起始位置
                inputElement.selectionEnd = 2; // 设置光标的结束位置
            }
        }


    };

    handleInputBlur = () => {
        this.setState({
            focusedInput: '',
        });
    };

    toggleContent1 = () => {
        this.setState(prevState => ({
            showContent1: !prevState.showContent1
        }));
        this.setState(prevState => ({
            buttonDesign1: prevState.buttonDesign1 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent2 = () => {
        this.setState(prevState => ({
            showContent2: !prevState.showContent2
        }));
        this.setState(prevState => ({
            buttonDesign2: prevState.buttonDesign2 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent3 = () => {
        this.setState(prevState => ({
            showContent3: !prevState.showContent3
        }));
        this.setState(prevState => ({
            buttonDesign3: prevState.buttonDesign3 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent4 = () => {
        this.setState(prevState => ({
            showContent4: !prevState.showContent4
        }));
        this.setState(prevState => ({
            buttonDesign4: prevState.buttonDesign4 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent5 = () => {
        this.setState(prevState => ({
            showContent5: !prevState.showContent5
        }));
        this.setState(prevState => ({
            buttonDesign5: prevState.buttonDesign5 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent6 = () => {
        this.setState(prevState => ({
            showContent6: !prevState.showContent6
        }));
        this.setState(prevState => ({
            buttonDesign6: prevState.buttonDesign6 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent7 = () => {
        this.setState(prevState => ({
            showContent7: !prevState.showContent7
        }));
        this.setState(prevState => ({
            buttonDesign7: prevState.buttonDesign7 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    toggleContent8 = () => {
        this.setState(prevState => ({
            showContent8: !prevState.showContent8
        }));
        this.setState(prevState => ({
            buttonDesign8: prevState.buttonDesign8 === 'plus_button' ? 'minus_button' : 'plus_button'
        }));
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const firstname = document.getElementById('c_firstname').value;
        const lastname = document.getElementById('c_lastname').value;
        const email = document.getElementById('c_email').value;
        const title = document.getElementById('c_title').value;
        const company = document.getElementById('c_company').value;
        const subject = this.state.subject;
        const message = document.getElementById('message').value;

        function isValidName(name){
            const pattern = /^[a-zA-Z\s]+$/;
            return pattern.test(name);
        }

        function isValidEmail(email){
            const pattern = /\S+@\S+\.\S+/;
            return pattern.test(email);
        }

        function isValidTitle(title){
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(title);
        }

        function isValidCompany(company) {
            const pattern = /^[a-zA-Z0-9\s.]+$/;
            return pattern.test(company);
        }

        function displayErrorMessage(errorId, errorMessage) {
            const errorElement = document.getElementById(errorId);
            if (errorElement) {
                errorElement.innerHTML = `<span class="error-icon"></span> ${errorMessage}`;

            }
        }

        function resetErrorMessages() {
            const errorElements = document.querySelectorAll('.c-error-message,.c-error-message2');
            errorElements.forEach((errorElement) => {
                errorElement.textContent = '';
            });

        }


        if (!isValidName(firstname) ||!isValidName(lastname)|| !isValidTitle(title) || !isValidCompany(company) || !isValidEmail(email)||firstname===""||lastname===""||title===""||company===""||email===""||subject==""||message ==""
        ){
            console.log("can't submit")
            if(!isValidName(firstname)||firstname===''){
                const inputElement = document.getElementById('c_firstname');
                if(inputElement) {
                    if (firstname === '') {
                        displayErrorMessage('first-name-error', 'Please enter your firstname');
                        const labelElement = document.querySelector('label[for="c_firstname"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');

                    } else if (!isValidName(firstname)) {
                        displayErrorMessage('first-name-error', 'Invalid Name');
                        const labelElement = document.querySelector('label[for="c_firstname"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');

                    } else {
                        resetErrorMessages('first-name-error');
                        const labelElement = document.querySelector('label[for="c_firstname"]');
                        if (labelElement) {
                            labelElement.classList.remove('error');
                        }
                        inputElement.classList.remove('error_input');

                    }
                }
            }

            else if(!isValidName(lastname)||lastname===''){
                const inputElement = document.getElementById('c_lastname');
                if(inputElement){
                    if (lastname=== '') {
                        displayErrorMessage('last-name-error', 'Please enter your lastname');
                        const labelElement = document.querySelector('label[for="c_lastname"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else if (!isValidName(lastname)) {
                        displayErrorMessage('last-name-error', 'Invalid Name');
                        const labelElement = document.querySelector('label[for="c_lastname"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else {
                        resetErrorMessages('last-name-error');
                        const labelElement = document.querySelector('label[for="c_lastname"]');
                        if (labelElement) {
                            labelElement.classList.remove('error');
                        }
                        inputElement.classList.remove('error_input');
                    }
                }
            }

            else if(!isValidEmail(email)||email===''){
                const inputElement = document.getElementById('c_email');
                if (inputElement) {
                    if (email==='') {
                        displayErrorMessage('email-error', 'Please enter your email address');
                        const labelElement = document.querySelector('label[for="c_email"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else if (!isValidEmail(email)) {
                        displayErrorMessage('email-error', 'Invalid Email Address');
                        const labelElement = document.querySelector('label[for="c_email"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else {
                        resetErrorMessages('email-error');
                        const labelElement = document.querySelector('label[for="c_email"]');
                        if (labelElement) {
                            labelElement.classList.remove('error');
                        }
                        inputElement.classList.remove('error_input');
                    }
                }

            }

            else if(!isValidTitle(title)||title===''){
                const inputElement = document.getElementById('c_title');
                if(inputElement) {
                    if (title==='') {
                        displayErrorMessage('title-error', 'Please enter your title');
                        const labelElement = document.querySelector('label[for="c_title"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else if (!isValidTitle(title)) {
                        displayErrorMessage('title-error', 'Invalid Title');
                        const labelElement = document.querySelector('label[for="c_title"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else {
                        resetErrorMessages('title-error');
                        const labelElement = document.querySelector('label[for="c_title"]');
                        if (labelElement) {
                            labelElement.classList.remove('error');
                        }
                        inputElement.classList.remove('error_input');
                    }
                }
            }

            else if(!isValidCompany(company)||company===''){
                const inputElement = document.getElementById('c_company');
                if(inputElement) {
                    if (company==='') {
                        displayErrorMessage('company-error', 'Please enter your company');
                        const labelElement = document.querySelector('label[for="c_company"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else if (!isValidCompany(company)) {
                        displayErrorMessage('company-error', "Invalid Company's Name");
                        const labelElement = document.querySelector('label[for="c_company"]');
                        if (labelElement) {
                            labelElement.classList.add('error');
                        }
                        inputElement.classList.add('error_input');
                    } else {
                        resetErrorMessages('company-error');
                        const labelElement = document.querySelector('label[for="c_company"]');
                        if (labelElement) {
                            labelElement.classList.remove('error');
                        }
                        inputElement.classList.remove('error_input');
                    }

                }
            } else if(subject ===''){
                if(this.state.subject ===''){

                    displayErrorMessage('subject-error', 'Please enter your subject');
                } else{
                    resetErrorMessages('subject-error');
                }
                
            } else if(message ===''){
                console.log('Empty message!')
                displayErrorMessage('message-error', 'Please enter the details of your inquiry');
            }

        } else{
            const formObj1 = {
                fields: {
                    Firstname: firstname,
                    Lastname: lastname,
                    Email: email,
                    Title: title,
                    Company: company,
                    Subject: subject,
                    Message: message,
                },
            };

            const jsonString1 = JSON.stringify(formObj1);

            // fetch('https://open.larksuite.com/open-apis/bitable/v1/apps/ATg9bhnb3aIYxnszKfLuBHaas0d/tables/tblJjWRlTSNIKnJD/records', {
            //     method: 'POST',
            //     headers: {
            //         Authorization: 'Bearer u-dplejl3iZdxpKBaSt.kg5xB4mfzl1511iyw00gs00F2q',
            //         'Content-Type': 'application/json', 
            //     },
            fetch('https://api.airtable.com/v0/app4zRlCbgnEsm8Up/ContactInformation', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer keyzcpXsupauEJBhZ',
                    'Content-Type': 'application/json',
                },
                body: jsonString1,
            })
                .then((response) => response.json())
                .then((data) => console.log(data))
                .catch((error) => console.error('Error:', error));

            // Clear form fields
            this.setState({
                email: '',
                firstname: '',
                lastname: '',
                title: '',
                company: '',
                subject: '',
                message: '',
                wordCount: 0,
                focusedInput: '',
                errors: {},
                submitted:true,
            });
            // }
        }
        window.scrollTo(0, 675); // 滚动到页面顶部

    };






    // handleInputChange = (event) => {
    //     const value = event.target.value;
    //     const wordCount = this.countWords(value);
    //
    //     this.setState({
    //         [event.target.name]: value,
    //         wordCount: wordCount
    //     });
    // };
    handleInputChange = (event) => {
        
        function isValidName(name){
            const pattern = /^[a-zA-Z\s]+$/;
            return pattern.test(name);
        }

        function isValidEmail(email){
            const pattern = /\S+@\S+\.\S+/;
            return pattern.test(email);
        }

        function isValidTitle(title){
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(title);
        }

        function isValidCompany(company) {
            const pattern = /^[a-zA-Z0-9\s.]+$/;
            return pattern.test(company);
        }


        function displayErrorMessage(errorId, errorMessage) {
            const errorElement = document.getElementById(errorId);
            if (errorElement) {
                errorElement.innerHTML = `<span class="error-icon"></span> ${errorMessage}`;

            }
        }


        function resetErrorMessages() {
            const errorElements = document.querySelectorAll('.c-error-message,.c-error-message2');
            errorElements.forEach((errorElement) => {
                errorElement.textContent = '';
            });

        }



        const value = event.target.value;
        const name = event.target.name;

        let wordCount;
        let store;
        if (name === 'message') {
            wordCount = 0;
            if (value !== 'message'&& value !== '') {
                wordCount = this.countWords(value);
            }
        }




        this.setState({
            [name]: value,
            wordCount: wordCount,
            errors: {
                firstname: '', // Initialize or reset the error message for each field
                lastname: '',
                email: '',
                title: '',
                company: '',
                message: '',
            },
        });


        // Validation logic
        if (name === 'firstname') {
            const inputElement = document.getElementById('c_firstname');
            if (inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('first-name-error', 'Please enter your first name');
                    const labelElement = document.querySelector('label[for="c_firstname"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');

                } else if (!isValidName(value)) {
                    displayErrorMessage('first-name-error', 'Invalid name');
                    const labelElement = document.querySelector('label[for="c_firstname"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');

                } else {
                    resetErrorMessages('first-name-error');
                    const labelElement = document.querySelector('label[for="c_firstname"]');
                    if (labelElement) {
                        labelElement.classList.remove('error');
                    }
                    inputElement.classList.remove('error_input');

                }
            }
        } else if (name === 'lastname') {
            const inputElement = document.getElementById('c_lastname');
            if(inputElement){
                if (value.trim() === '') {
                    displayErrorMessage('last-name-error', 'Please enter your last name');
                    const labelElement = document.querySelector('label[for="c_lastname"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else if (!isValidName(value)) {
                    displayErrorMessage('last-name-error', 'Invalid name');
                    const labelElement = document.querySelector('label[for="c_lastname"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else {
                    resetErrorMessages('last-name-error');
                    const labelElement = document.querySelector('label[for="c_lastname"]');
                    if (labelElement) {
                        labelElement.classList.remove('error');
                    }
                    inputElement.classList.remove('error_input');
                }
            }
        } else if (name === 'email') {
            const inputElement = document.getElementById('c_email');
            if (inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('email-error', 'Please enter your email address');
                    const labelElement = document.querySelector('label[for="c_email"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else if (!isValidEmail(value)) {
                    displayErrorMessage('email-error', 'Invalid email address');
                    const labelElement = document.querySelector('label[for="c_email"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else {
                    resetErrorMessages('email-error');
                    const labelElement = document.querySelector('label[for="c_email"]');
                    if (labelElement) {
                        labelElement.classList.remove('error');
                    }
                    inputElement.classList.remove('error_input');
                }
            }
        } else if (name === 'title') {
            const inputElement = document.getElementById('c_title');
            if(inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('title-error', 'Please enter your title');
                    const labelElement = document.querySelector('label[for="c_title"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else if (!isValidTitle(value)) {
                    displayErrorMessage('title-error', 'Invalid title');
                    const labelElement = document.querySelector('label[for="c_title"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else {
                    resetErrorMessages('title-error');
                    const labelElement = document.querySelector('label[for="c_title"]');
                    if (labelElement) {
                        labelElement.classList.remove('error');
                    }
                    inputElement.classList.remove('error_input');
                }
            }
        } else if (name === 'company') {
            const inputElement = document.getElementById('c_company');
            if(inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('company-error', 'Please enter your company');
                    const labelElement = document.querySelector('label[for="c_company"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else if (!isValidCompany(value)) {
                    displayErrorMessage('company-error', "Invalid company's name");
                    const labelElement = document.querySelector('label[for="c_company"]');
                    if (labelElement) {
                        labelElement.classList.add('error');
                    }
                    inputElement.classList.add('error_input');
                } else {
                    resetErrorMessages('company-error');
                    const labelElement = document.querySelector('label[for="c_company"]');
                    if (labelElement) {
                        labelElement.classList.remove('error');
                    }
                    inputElement.classList.remove('error_input');
                }

            }
        } else if (name === 'subject') {
            if (value !=''){
                const errorElement = document.querySelector('.subject-error-message');
               
                errorElement.style.display = 'none';
                
            }
        
        } else if (name === 'message' && wordCount > 300) {
            const trimmedText = value.trim();
            const words = trimmedText.split(/\s+/);
            const truncatedText = words.slice(0, 300).join(' ');
            wordCount = 300;

            this.setState({
                [name]: truncatedText,
                wordCount: wordCount,
            });

            displayErrorMessage('message-error', `! ${wordCount}/300 words`);
        } else {
            this.setState({
                [name]: value,
                wordCount: wordCount,
            });

            resetErrorMessages('message-error');
        }
    }






    countWords = (text) => {
        const trimmedText = text.trim();
        if (trimmedText === "") {
            return 0;
        } else {
            const words = trimmedText.split(/\s+/);
            if (words.length> 300) {
                text= text.split(' ', 300).join(' ');
            }

            return words.length;
        }
    };

    render(){
        const {
            email,
            firstname,
            lastname,
            title,
            company,
            subject,
            message,
            wordCount,
            focusedInput,
            showContent1,
            showContent2,
            showContent3,
            showContent4,
            showContent5,
            showContent6,
            showContent7,
            showContent8,
            buttonDesign1,
            buttonDesign2,
            buttonDesign3,
            buttonDesign4,
            buttonDesign5,
            buttonDesign6,
            buttonDesign7,
            buttonDesign8,
            isMobile,
            submitted,
        } = this.state;

        return (
            <div className="contact-main-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <div className='contact-header'>
                {submitted && 
                            <div className = 'notice-cover1'>
                                <div className='notice_pic1'>
                                    
                                    <div className='notice-text1'>
                                        You have successfully submitted your contact information!
                                    </div>
                                    <button className='notice-logo1' onClick = {this.clickCancel}>Close</button>
                                </div>
                            </div>}


                    <div class='contact-container'>
                        <div class='c-container'>

                            {/*<div class='contact_pic'>*/}
                            <div class='contact_info'>
                                <div class='contact_pic'>
                                    <div class='part_1'>
                                        <div className='contact_content_detail'>
                                            <h4 className='contact_text1'>Contact Information</h4>
                                        </div>
                                    </div>
                                    <div class='part_2'>
                                        <div className='contact_content_detail'>
                                            <img className='phone_img' alt="pic"/>
                                            <h4 className='contact_text2'>+1 (415) 632 8638</h4>
                                        </div>
                                        <div className='contact_content_detail'>
                                            <img className='email_img' alt="pic"/>
                                            <a href="mailto:blake@svlc.tech" className="contact_text3">blake@svlc.tech</a>
                                        </div>
                                        <div className='contact_content_detail'>
                                            <img className='location_img' alt="pic"/>
                                            <h4 className='contact_text4'>Silicon Valley, CA USA</h4>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='white-board'></div>
                    </div>


                </div>
                <h1 className='contact_header_title'>Contact Us</h1>

                <div class='contact-white-container'>
                    <form method="post"  id="c_form" >
                        {/*<form>*/}
                        <div class='form-row'>
                            <h2 className='contact_title'>Contact Us</h2>
                        </div>

                        <div className='form-row'>

                           <div className={`form-group ${focusedInput === 'firstname' ? 'focused' : ''}`}>
                                {focusedInput !== 'firstname' ? <div></div> : <label for="c_firstname" className='fname_label'>First Name *</label>}
                                {/*{`lname_label ${this.state.errors.lastname ? 'lname_error_label' : ''}`}*/}
                                <input
                                    class="contact_box_firstname"
                                    type="text"
                                    name="firstname"
                                    id="c_firstname"
                                    value={firstname}
                                    ref={this.firstnameInput} // 将 ref 附加到输入元素
                                    onChange={this.handleInputChange}
                                    onFocus={() => this.handleInputFocus('firstname')}
                                    onBlur={this.handleInputBlur}
                                    required
                                    placeholder={focusedInput !== 'firstname' ? 'First Name *' : ''}
                                />
                                <span id="first-name-error" className="c-error-message"></span>
                                {/*{this.state.errors.lastname && <span id="last-name-error" className="error-message">{this.state.errors.lastname}</span>}*/}

                            </div>


                            <div className={`form-group ${focusedInput === 'lastname' ? 'focused' : ''}`}>
                                {focusedInput !== 'lastname' ? <div></div> : <label for="c_lastname" className='lname_label'>Last Name *</label>}
                                {/*{`lname_label ${this.state.errors.lastname ? 'lname_error_label' : ''}`}*/}
                                <input
                                    class="contact_box_lastname"
                                    type="text"
                                    name="lastname"
                                    id="c_lastname"
                                    value={lastname}
                                    ref={this.lastnameInput} // 将 ref 附加到输入元素
                                    onChange={this.handleInputChange}
                                    onFocus={() => this.handleInputFocus('lastname')}
                                    onBlur={this.handleInputBlur}
                                    required
                                    placeholder={focusedInput !== 'lastname' ? 'Last Name *' : ''}
                                />
                                <span id="last-name-error" className="c-error-message2"></span>
                                {/*{this.state.errors.lastname && <span id="last-name-error" className="error-message">{this.state.errors.lastname}</span>}*/}

                            </div>


                        </div>

                        <div className={`form-group ${focusedInput === 'email' ? 'focused' : ''}`}>
                            {focusedInput !== 'email' ? <div></div> : <label for="c_email"
                                                                             className={`email_label ${this.state.errors.email ? 'email_error_label' : ''}`}> Email Address *</label>}
                            <input
                                class="contact_box_email"
                                type="text"
                                name="email"
                                id="c_email"
                                value={email}
                                ref={this.emailInput} // 将 ref 附加到输入元素
                                onChange={this.handleInputChange}
                                onFocus={() => this.handleInputFocus('email')}
                                onBlur={this.handleInputBlur}
                                required
                                placeholder={focusedInput !== 'email' ? 'Email Address *' : ''}
                            />
                            <span id="email-error" className="c-error-message"></span>
                            {/*{this.state.errors.email && <span id="email-error" className="error-message">{this.state.errors.email}</span>}*/}

                        </div>


                        <div className='form-row'>

                            <div className={`form-group ${focusedInput === 'title' ? 'focused' : ''}`}>
                                {focusedInput !== 'title' ? <div></div> : <label for="c_title"
                                                                                 className={`title_label ${this.state.errors.title ? 'title_error_label' : ''}`}>Title *</label>}
                                <input
                                    class="contact_box_title"
                                    type="text"
                                    name="title"
                                    id="c_title"
                                    value={title}
                                    ref={this.titleInput} // 将 ref 附加到输入元素
                                    onChange={this.handleInputChange}
                                    onFocus={() => this.handleInputFocus('title')}
                                    onBlur={this.handleInputBlur}
                                    required
                                    placeholder={focusedInput !== 'title' ? 'Title *' : ''}
                                />
                                <span id="title-error" className="c-error-message"></span>
                                {/*{this.state.errors.title && <span id="title-error" className="error-message">{this.state.errors.title}</span>}*/}

                            </div>


                            <div className={`form-group ${focusedInput === 'company' ? 'focused' : ''}`}>
                                {focusedInput !== 'company' ? <div></div> : <label for="c_company"
                                                                                   className={`company_label ${this.state.errors.company ? 'company_error_label' : ''}`}>Company *</label>}
                                <input
                                    class="contact_box_company"
                                    type="text"
                                    name="company"
                                    id="c_company"
                                    value={company}
                                    ref={this.companyInput} // 将 ref 附加到输入元素
                                    onChange={this.handleInputChange}
                                    onFocus={() => this.handleInputFocus('company')}
                                    onBlur={this.handleInputBlur}
                                    required
                                    placeholder ={focusedInput !== 'company' ? 'Company *' : ''}
                                />
                                <span id="company-error" className="c-error-message2"></span>
                                {/*{this.state.errors.company && <span id="company-error" className="error-message">{this.state.errors.company}</span>}*/}

                            </div>


                        </div>



                        <h2 className='contact_subject'>Select Subject</h2>

                        <div class="row">
                            <section class="form">
                            <span id="subject-error" className="subject-error-message"  ></span>
                                <div class="input-wrapper">
                                    <input type="radio" name="subject" id="radio1"
                                           value="Member Registration"
                                           checked={subject === 'Member Registration'}
                                           onChange={this.handleInputChange}/>
                                    <label class="radio-label" for="radio1">Member Registration</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="radio" name="subject" id="radio2"
                                           value="Business Inquiry"
                                           checked={subject === 'Business Inquiry'}
                                           onChange={this.handleInputChange} />
                                    <label class="radio-label" for="radio2">Business Inquiry</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="radio" name="subject" id="radio3"
                                           value="Press Inquiry"
                                           checked={subject === 'Press Inquiry'}
                                           onChange={this.handleInputChange}/>
                                    <label class="radio-label" for="radio3">Press Inquiry</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="radio" name="subject" id="radio4"
                                           value="General Inquiry"
                                           checked={subject === 'General Inquiry'}
                                           onChange={this.handleInputChange}/>
                                    <label class="radio-label" for="radio4">General Inquiry</label>
                                </div>
                                
                            </section>
                        </div>


                        <h2 className='contact_subject'>Message</h2>

                    
                    <div className={`form-group ${focusedInput === 'message' ? 'focused' : ''}`}>
                       <textarea
                           name="message"
                           id="message"
                           value={message}
                           className="contact_box_message"
                           onChange={this.handleInputChange}
                           onFocus={() => this.handleInputFocus('message')}
                           onBlur={this.handleInputBlur}
                           placeholder={focusedInput !== 'message' ? 'Is there anything else we should know about you?' : ''}
                       ></textarea> <label id="wordCount">{wordCount}/300</label>
                            


                        </div>
                        
                        <button class='contact_more_button' onClick = {this.handleSubmit}> Submit</button>
                        {isMobile && 
                        < div className='new-container'>
                            <div className = "contact-new">
                            
                                    <div className = "info-group1">
                                        <img className='info_phone_img' alt="pic"/>
                                        <h4 className='contact-information1'>+1 (415) 632 8638</h4>
                                    </div>
                                
                                    <div className = "info-group1">
                                        <img className='info_email_img' alt="pic"/>
                                        <a href="mailto:blake@svlc.tech" className="contact-information2">blake@svlc.tech</a>
                                    </div>
                            
                                    <div className = "info-group1">
                                        <img className='info_location_img' alt="pic"/>
                                        <h4 className='contact-information3'>Silicon Valley, CA USA</h4>
                                    </div>
                            </div>
                        </div>
                        }
                    </form>
                    <div classname ="qa_container">
                        <div className = "Questions-header">General Questions</div>
                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[0]}</div>
                            <button className={`button ${buttonDesign1}`} onClick={this.toggleContent1} />
                        </div>
                        {showContent1 && <div className = "a1"><p>
                        {this.state.answers[0].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[0].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}
                            </p></div> }

                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[1]}</div>
                            <button className={`button ${buttonDesign2}`} onClick={this.toggleContent2} />
                        </div>
                        {showContent2 && <div className = "a1"><p>
                            {this.state.answers[1].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[1].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}</p></div> }

                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[2]}</div>
                            <button className={`button ${buttonDesign3}`} onClick={this.toggleContent3} />
                        </div>
                        {/* {showContent3 && <div className = "a1"><p>
                            By becoming a member of SVLC, you gain access to a vibrant community of leaders, executives, and industry experts.
                            <br></br> <br></br> Some key benefits include:
                            <br></br>  - Networking opportunities with like-minded professionals from diverse backgrounds
                            <br></br>  - Access to exclusive events, workshops, and conferences featuring renowned speakers and thought leaders
                            <br></br>  - Learning and development resources, including webinars, articles, and whitepapers, which will benefit your career advancement
                            <br></br>  - Exposure to the latest trends and innovations in leadership and technology</p></div> } */}
                            {showContent3 && <div className = "a1"><p>
                            {this.state.answers[2].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[2].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}
                                </p></div> }
                        <div className = "line"></div>

                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[3]}</div>
                            <button className={`button ${buttonDesign4}`} onClick={this.toggleContent4} />
                        </div>
                        {showContent4 && <div className = "a1"><p>                            
                            {this.state.answers[3].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[3].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))} </p>  </div> }
                        <div className = "line"></div>


                        <div className = "FAQ-header">FAQ</div>
                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[4]}</div>
                            <button className={`button ${buttonDesign5}`} onClick={this.toggleContent5} />
                        </div>
                        {showContent5 && <div className = "a1"><p>                            
                            {this.state.answers[4].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[4].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}</p></div> }

                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[5]}</div>
                            <button className={`button ${buttonDesign6}`} onClick={this.toggleContent6} />
                        </div>
                        {showContent6 && <div className = "a1"><p>
                        {this.state.answers[5].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[5].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}</p></div> }

                        <div className = "line"></div>
                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[6]}</div>
                            <button className={`button ${buttonDesign7}`} onClick={this.toggleContent7} />
                        </div>
                        {showContent7 && <div className = "a1"><p>                           
                             {this.state.answers[6].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[6].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}</p></div> }
                        <div className = "line"></div>

                        <div className='question_section'>
                            <div className = "q1">{this.state.questions[7]}</div>
                            <button className={`button ${buttonDesign8}`} onClick={this.toggleContent8} />
                        </div>
                        {showContent8 && <div className = "a1"><p>                           
                             {this.state.answers[7].split('<br/>').map((line, lineIndex) => (
                            <React.Fragment key={lineIndex}>
                                 {line}
                             {lineIndex !== this.state.answers[7].split('<br/>').length - 1 && <br />}
                        </React.Fragment>
                                       ))}</p></div> }

                        <div className = "line"></div>
                    </div>
                </div>

            </div>

        )
    }
}


export default withRouter(Contact);